export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    if ($('.js-hero-carousel').length) {
      $('.js-hero-carousel').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 10000,
        arrows: false,
        fade: true,
        speed: 1000,
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js